import img2 from "../assets/HeroSlider/hero2.jpg";
import img6 from "../assets/HeroSlider/hero6.jpg";
import img7 from "../assets/HeroSlider/hero7.jpg";
import anniversaryImage from "../assets/1st-anniversairy.jpeg";
import firstWinImage from "../assets/first-win.jpg";
import topScorerImage from "../assets/top-scorer.jpg";

const publicUrl = process.env.PUBLIC_URL || "";
const memorialEventLink =
  "https://www.facebook.com/events/ul-promienista-27-pozna%C5%84/xii-memoria%C5%82-im-henryka-zielazka/2474173056389378/";
const memorialGalleryLink = "/gallery#memorial-zielazka";
const memorialCover = `${publicUrl}/gallery/memorial-zielazka/1.jpg`;
const orletaGalleryLink = "/gallery#mecz-orleta";

const newsItems = [
  {
    id: "first-anniversary",
    category: {
      pl: "Klub",
      en: "Club",
    },
    title: {
      pl: "Pierwszy rok Warsaw Hockey Club",
      en: "The first year of Warsaw Hockey Club",
    },
    excerpt: {
      pl: "4 czerwca minal dokladnie rok od oficjalnej rejestracji stowarzyszenia Warsaw Hockey Club. To byl rok budowania druzyny, pierwszych meczow, nowych przyjazni i coraz mocniejszej obecnosci hokeja na trawie w Warszawie.",
      en: "June 4 marked exactly one year since Warsaw Hockey Club was officially registered. It has been a year of building the team, playing our first matches, creating new friendships, and giving field hockey a stronger presence in Warsaw.",
    },
    date: "2026-06-04",
    image: anniversaryImage,
    actions: [
      {
        label: {
          pl: "Instagram",
          en: "Instagram",
        },
        link: "https://www.instagram.com/p/DZKp2kfIXmC/",
        external: true,
      },
    ],
  },
  {
    id: "top-scorer-joseph-ncube",
    category: {
      pl: "Druzyna",
      en: "Team",
    },
    title: {
      pl: "Joseph Ncube naszym najlepszym strzelcem",
      en: "Joseph Ncube is our top scorer",
    },
    excerpt: {
      pl: "Joseph Ncube ma obecnie 12 goli w 13 meczach i pozostaje naszym najlepszym strzelcem. Doceniamy jego konsekwencje, odwage pod bramka i gole, ktore daja druzynie energie przed ostatnim meczem sezonu.",
      en: "Joseph Ncube currently has 12 goals in 13 matches and remains our top scorer. We value his consistency, sharp finishing, and the goals that keep giving the team energy ahead of the final match of the season.",
    },
    date: "2026-06-02",
    image: topScorerImage,
    actions: [
      {
        label: {
          pl: "Sprawdz lige",
          en: "Check league updates",
        },
        link: "/league",
        external: false,
      },
    ],
  },
  {
    id: "memorial-zielazka",
    category: {
      pl: "Turniej",
      en: "Tournament",
    },
    title: {
      pl: "XII Memorial im. Henryka Zelazka w Poznaniu",
      en: "12th Henryk Zelazka Memorial in Poznan",
    },
    excerpt: {
      pl: "Turniej dla dzieci i mlodziezy zgromadzil na Promienistej ponad 20 druzyn z calej Polski. Dodalismy juz galerie zdjec z wydarzenia oraz bezposredni link do strony wydarzenia na Facebooku.",
      en: "The youth tournament at Promienista brought together more than 20 teams from across Poland. We have added a dedicated photo gallery and a direct link to the Facebook event page.",
    },
    date: "2026-05-30",
    time: "09:30",
    location: {
      pl: "Boisko, ul. Promienista 27, Poznan",
      en: "Pitch, 27 Promienista Street, Poznan",
    },
    image: memorialCover,
    actions: [
      {
        label: {
          pl: "Wydarzenie na Facebooku",
          en: "Facebook event",
        },
        link: memorialEventLink,
        external: true,
      },
      {
        label: {
          pl: "Zobacz galerie",
          en: "View gallery",
        },
        link: memorialGalleryLink,
        external: false,
      },
    ],
  },
  {
    id: "first-win-orleta",
    category: {
      pl: "Mecz",
      en: "Match",
    },
    title: {
      pl: "Pierwsze zwyciestwo: 3:1 z Orletami Sosnowiec",
      en: "First win: 3-1 against Orleta Sosnowiec",
    },
    excerpt: {
      pl: "23 maja 2026 odnioslismy pierwsze zwyciestwo w historii klubu na poziomie I ligi. Warsaw Hockey Club pokonal UKS Orleta Sosnowiec-Gornik 3:1, a na liste strzelcow wpisali sie dwa razy Joseph Ncube i raz Fabian Skalec.",
      en: "On May 23, 2026, we earned the first league win in club history. Warsaw Hockey Club beat UKS Orleta Sosnowiec-Gornik 3-1, with two goals from Joseph Ncube and one from Fabian Skalec.",
    },
    date: "2026-05-23",
    time: "18:00",
    location: {
      pl: "Warszawa, ul. Marymoncka 34, boisko nr 3",
      en: "Warsaw, 34 Marymoncka Street, pitch 3",
    },
    image: firstWinImage,
    actions: [
      {
        label: {
          pl: "Zobacz galerie",
          en: "View gallery",
        },
        link: orletaGalleryLink,
        external: false,
      },
      {
        label: {
          pl: "Sprawdz lige",
          en: "Check league updates",
        },
        link: "/league",
        external: false,
      },
    ],
  },
  {
    id: "national-sports-day",
    category: {
      pl: "Wydarzenie",
      en: "Event",
    },
    title: {
      pl: "Piknik 14 wrzesnia",
      en: "Picnic on September 14",
    },
    excerpt: {
      pl: "Zapraszamy na Narodowy Dzien Sportu na bloniach PGE Narodowego. Bedziemy na miejscu z aktywnosciami, grami i szybkim wprowadzeniem do hokeja na trawie.",
      en: "Join us at National Sports Day on the grounds of PGE Narodowy. We will be there with activities, games, and an easy first step into field hockey.",
    },
    date: "2025-09-03",
    image: img7,
    actions: [
      {
        label: {
          pl: "Czytaj dalej",
          en: "Read more",
        },
        link: "https://narodowydziensportu.pl/piknik-w-warszawie",
        external: true,
      },
    ],
  },
  {
    id: "season-start",
    category: {
      pl: "Sezon",
      en: "Season",
    },
    title: {
      pl: "Nowy sezon startuje 7 wrzesnia",
      en: "The new season starts on September 7",
    },
    excerpt: {
      pl: "Wchodzimy w nowy sezon z nowa energia, nowymi zawodnikami i jasnym celem: budowac coraz silniejsza druzyne w Warszawie.",
      en: "We are entering the new season with fresh energy, new players, and a clear goal: build a stronger team in Warsaw step by step.",
    },
    date: "2025-09-01",
    image: img6,
    actions: [
      {
        label: {
          pl: "Sprawdz lige",
          en: "Check league updates",
        },
        link: "/league",
        external: false,
      },
    ],
  },
  {
    id: "capital-debut",
    category: {
      pl: "Klub",
      en: "Club",
    },
    title: {
      pl: "Hokej na trawie wraca do stolicy",
      en: "Field hockey returns to the capital",
    },
    excerpt: {
      pl: "Warsaw Hockey Club dolacza do rozgrywek I ligi seniorow. To wazny krok dla klubu i dla rozwoju hokeja na trawie w Warszawie.",
      en: "Warsaw Hockey Club joins the Polish League I competition. It is an important step both for the club and for the growth of field hockey in Warsaw.",
    },
    date: "2025-08-30",
    image: img2,
    actions: [
      {
        label: {
          pl: "Czytaj dalej",
          en: "Read more",
        },
        link: "https://www.facebook.com/reel/1308634974382451/",
        external: true,
      },
    ],
  },
];

export default newsItems;
